import * as logger from "@sentry/react";
import { RELEASE, SENTRY_DSN, ENV_NAME } from "./config";

logger.init({
  dsn: SENTRY_DSN,
  environment: ENV_NAME,
  release: RELEASE,
  ignoreErrors: [
    /Failed to fetch/i,
    /NetworkError/i,
    /Network Error/i,
    /Load failed/i,
    /aborted/i,
    "TypeError: cancelled",
    "cancelled",
    "SyntaxError: Unexpected token '<'",
  ],
  tracesSampler: (samplingContext) => {
    if (samplingContext.transactionContext.name.includes("Unexpected token")) {
      return 0.01;
    } else {
      return 0.5;
    }
  },
});

export default logger;
